module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_2048.5b1f32f6.webp";